export default {
  /**
   * Object to query string converter.
   * This function converts an object into a query string format.
   * It handles nested objects and arrays by flattening them into a single string.
   *
   *
   * @param params - The object to be converted to a query string.
   * @returns A string representing the query parameters.
   */
  buildQueryParamsString(params?: Record<string, any>): string {
    if (!params) return '';
    if (typeof params !== 'object') {
      return String(params);
    }
    const qp = new URLSearchParams();
    Object.entries(params).forEach(([key, val]) => {
      if (val === undefined || val === null) return;
      if (Array.isArray(val)) val.forEach((v) => qp.append(key, String(v)));
      else qp.append(key, String(val));
    });
    return qp.toString();
  },

  /**
   * Converts an object to a query string with enhanced readability for arrays.
   */
  objectParamsToString(
    params: Record<string, any>,
    options: { encode?: boolean } = {},
  ): string {
    const { encode = true } = options;
    return Object.entries(params)
      .map(([key, value]) => {
        const encodedKey = encode ? encodeURIComponent(key) : key;
        let encodedValue;

        if (Array.isArray(value)) {
          // Handle arrays by joining values with commas and wrapping in square brackets
          const arrayValue = value.map((v) => (encode ? encodeURIComponent(v) : v)).join(',');
          encodedValue = `[${arrayValue}]`;
        } else {
          encodedValue = encode ? encodeURIComponent(value) : value;
        }

        return `${encodedKey}=${encodedValue}`;
      })
      .join('|');
  },
};
